import React, { useState, useMemo, useCallback } from 'react';
import { Button, SearchField, SearchTree } from '@ihsm/ui-shared';
import { useActions, useAppSelector } from 'state/store';

export interface SearchTreeMetricsProps {
  disableAddButton?: boolean;
}

export const SearchTreeMetrics: React.FC<SearchTreeMetricsProps> = ({
  disableAddButton,
}) => {
  const { isSearchTreeCollapsed } = useAppSelector((state) => state.uiState);
  const { toggleSearchTree } = useActions();
  const [filter, setFilter] = useState<string>();
  const { setSelectedMetricId } = useActions();
  const { metricsList, selectedMetricId } = useAppSelector(
    (state) => state.metricsState
  );

  const searchList = useMemo(() => {
    if (!metricsList) return [];

    return metricsList.map((metric) => ({
      id: metric.metricId,
      date: new Date(metric.timestamp),
      title: metric.name,
      badge: metric.type,
    }));
  }, [metricsList]);

  const filteredList = useMemo(() => {
    if (filter && filter !== '') {
      const updatedList = [...searchList].filter((listItem) => {
        const filterClean = filter?.toLowerCase().trim() || '';

        const titleClean = listItem?.title?.toLowerCase().trim();
        const titleFound = titleClean?.indexOf(filterClean) !== -1;

        const badgeClean = listItem?.badge?.toLocaleLowerCase().trim();
        const badgeFound = badgeClean
          ? badgeClean?.indexOf(filterClean) !== -1
          : false;

        return titleFound || badgeFound;
      });

      return updatedList;
    }

    return searchList;
  }, [filter, searchList]);

  const handleChange = useCallback(
    (id: string | number) => setSelectedMetricId(id as string),
    [setSelectedMetricId]
  );

  return (
    <div className="search-tree-report">
      <SearchTree
        header={
          <div className="search-tree-report__header">
            <SearchField delay={1000} onSearch={(value) => setFilter(value)} />
            <Button text="+" onClick={() => {}} disabled={disableAddButton} />
          </div>
        }
        list={filteredList}
        selectedId={selectedMetricId}
        onSelect={handleChange}
        isCollapsed={isSearchTreeCollapsed}
        toggleCollapsed={toggleSearchTree}
      />
    </div>
  );
};
